@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث بعض الخطأ' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions"
    [scopeResolver]="userScopeResolver"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="
      isArabic() ? 'جرّب تعديل الفلاتر أو أضف مستخدمًا جديدًا.' : 'Try adjusting your filters or add a new user.'
    "
    [emptyContentTitle]="isArabic() ? 'لا توجد سجلات مستخدمين' : 'No User Records Found'" />
}
